import {
  holoBuilderColorToSphereXGColor,
  SphereXGColors,
  sphereXGToHolobuilderColors,
} from "@/utils/waypoints-colors-mapping";
import { grey } from "@faro-lotv/flat-ui";
import { validateEnumValue } from "@faro-lotv/foundation";
import { HoloBuilderColors } from "@faro-lotv/ielement-types";

/** Mock of the dark color of the annotation pin, missing from the HoloBuilder colors of the backend */
export const DARK_ANNOTATION_COLOR = "dark";

/** A color of an annotation: one of the HoloBuilder colors, or the dark one of the pin */
export type AnnotationColor = HoloBuilderColors | typeof DARK_ANNOTATION_COLOR;

/** CSS color of the dark pin, which inherits the dark text color of the app */
const DARK_PIN_CSS = grey[1000];

/** CSS colors of the palette: the dark of the pin first, then the Sphere XG colors */
export const ANNOTATION_PALETTE = [
  DARK_PIN_CSS,
  ...Object.values(SphereXGColors),
];

/**
 * @param color color of an annotation, undefined for the default dark pin
 * @returns the CSS color to draw it
 */
export function annotationColorToCss(color?: AnnotationColor): string {
  if (!color || color === DARK_ANNOTATION_COLOR) return DARK_PIN_CSS;
  return holoBuilderColorToSphereXGColor(color);
}

/**
 * @param css one of the colors of ANNOTATION_PALETTE
 * @returns the annotation color it shows
 */
export function cssToAnnotationColor(css: string): AnnotationColor {
  return validateEnumValue(css, SphereXGColors)
    ? sphereXGToHolobuilderColors(css)
    : DARK_ANNOTATION_COLOR;
}
